module.exports = __webpack_public_path__ + "img/speed.5e50719.svg";